module.exports = __webpack_public_path__ + "static/media/experience_image_1@2x.35e6bc3b.png";